<script setup>
import { computed } from 'vue';
import { resolveDeskPlugin } from '../deskPluginRegistry';

const props = defineProps({
    slotName: { type: String, required: true },
    ticketId: { type: [String, Number], required: true },
    canOperate: { type: Boolean, default: false },
    customerEmail: { type: String, default: '' },
});

const plugin = computed(() => resolveDeskPlugin(props.slotName));
</script>

<template>
    <component
        :is="plugin"
        v-if="plugin"
        :ticket-id="ticketId"
        :can-operate="canOperate"
        :customer-email="customerEmail"
    />
</template>
